export const BaseURL = process.env.NODE_ENV === 'production' ? 'https://api.bacollege.ac.in/public' : 'http://localhost/bhawanipur-main/api/public';